<svelte:options tag="and-profile"></svelte:options>
<style style type="text/scss" lang="scss">
  @import "../../../global.scss";

  .dropdown {
    margin-left: auto;
    
    @include large-screen {
      overflow: hidden;
      margin-right: 6rem;
    }
  }

  .dropbtn {
    @include fontSize(18px);
    border: none;
    outline: none;
    color: $and-charcoal;
    padding: toRem(14px) toRem(16px);
    background-color: inherit;
    font-family: "Poppins", sans-serif;
    margin: 0;
  }

  .dropdown-content {
    display: block;

    @include large-screen {
      display: none;
      position: absolute;
      background-color: white;
      min-width: toRem(160px);
      box-shadow: toRem(0px) toRem(8px) toRem(16px) toRem(0px)
        rgba(0, 0, 0, 0.2);
      z-index: 1;
    }
  }

  .dropdown-content a {
    float: none;
    @include fontSize(14px);
    color: black;
    padding: toRem(12px) toRem(16px);
    text-decoration: none;
    font-family: "Poppins", sans-serif;
    display: block;
    text-align: left;
  }

  .dropdown-content a:hover {
    background-color: $and-blue;
  }

  .dropdown:hover .dropdown-content {
    display: block;
  }

  .menu-separator {
    border-width: 0;
    margin-top: 1rem;
    border-top: 1px solid $and-charcoal;
    margin-left: toRem(14px);
    width: 82vw;
  }
</style>

<script>
  export let id = 'and-nav-profile-id';

  export let loggedin;
  import Desktop from "../../../breakpoints/Desktop.svelte";
  import Phone from "../../../breakpoints/Phone.svelte";
  import profileIcon from "../../../../images/profile-icon.svg";
</script>

<div id="{id}" class="dropdown">
  <Desktop>
    <button class="dropbtn">
      <img src="{profileIcon}" alt="Profile icon dropdown menu" />
    </button>
  </Desktop>

  <div class="dropdown-content">
    <Phone>
      <hr class="menu-separator">
    </Phone>
    {#if loggedin}
    <slot name="loggedInSlot">
      <b>No profile logged in items</b>
    </slot>
    {/if} {#if !loggedin}
    <slot name="loggedOutSlot">
      <b>No profile logged out items</b>
    </slot>
    {/if}
    <Phone>
      <hr class="menu-separator">
    </Phone>
  </div>
</div>
